import {FC} from 'react'
import {Button} from '@components/ui/button/Button.tsx'
import {ChevronDownIcon} from '@components/ui/icon/Icon.tsx'
import {useTranslation} from '@/translations/i18n.tsx'
import {UsersMultiSelectPopover} from '@/features/users/components/users-multi-select-popover/UsersMultiSelectPopover'
import {UserSmall} from '@/features/users/types'

interface UserFilterMultiSelectProps {
    value: string[]
    onChange: (value: string[]) => void
}

export const UserFilterMultiSelect: FC<UserFilterMultiSelectProps> = ({value, onChange}) => {
    const {t} = useTranslation()

    const handleToggleClick = (user: UserSmall) => {
        const isSelected = value.includes(user.id)

        if (isSelected) {
            // Remove user
            const newValue = value.filter(id => id !== user.id)
            onChange(newValue)
        } else {
            // Add user
            const newValue = [...value, user.id]
            onChange(newValue)
        }
    }

    return (
        <UsersMultiSelectPopover
            selectedUserIds={value}
            toggleClick={handleToggleClick}
            trigger={
                <Button variant="secondary">
                    {value.length > 0
                        ? t('commons:x_selected', {count: value.length})
                        : t('table_filters:select_value')}

                    <ChevronDownIcon size={16} />
                </Button>
            }
        />
    )
}
